import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { Link, useNavigate } from 'react-router-dom';
import handleFetch from '../../api/handleFetch';
import Footer from '../../components/common/Footer';
import Loading from '../../components/common/Loading';
import TextInput from '../../components/inputs/TextInput';
import Button from '../../components/layouts/Button';
import FormHeader from '../../components/layouts/FormHeader';
import notification from '../../utils/notification';

function ForgetPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  // Mutations
  const forgotPasswordMutation = useMutation(handleFetch, {
    onSuccess: (res) => {
      if (res?.status) {
        notification({
          title: 'Success',
          message: `${res?.message}`,
          type: 'success'
        });

        navigate(`/reset-password/${encodeURIComponent(email)}`);
      }
    },
    onError: (err) => {
      notification({
        title: 'Error',
        message: err?.toString() || 'Something went wrong.',
        type: 'danger'
      });
    }
  });

  // Submit Actions
  const forgotPassword = (e) => {
    e.preventDefault();

    if (!email || email.length < 1) {
      notification({
        title: 'Form Error',
        message: 'Email is required',
        type: 'danger'
      });
      return;
    }

    forgotPasswordMutation.mutate({
      endpoint: 'forgotPassword',
      body: {
        email
      },
      method: 'POST'
    });
  };

  return (
    <div className="w-full h-screen bg-main-bg fixed top-0 left-0 overlay z-40 overflow-auto">
      {forgotPasswordMutation.isLoading && (
        <Loading />
      )}
      <div
        style={{ minHeight: 'calc(100vh - 72px)' }}
        className="w-full flex justify-center items-center p-5 pt-10 relative"
      >
        <div className="w-full max-w-sm p-5 bg-white rounded-lg">
          <FormHeader header="Forget Password" />
          <form className="mb-5" onSubmit={forgotPassword}>
            <TextInput
              className="mb-5"
              label="Email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button type="submit" paddingY="py-3" className="w-full">Submit</Button>
          </form>
          <div className="flex justify-between text-xs text-text-color">
            <Link to="/signup">New to this Admin Portal?</Link>
            <Link to="/">Return Home</Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>

  );
}

export default ForgetPassword;
